import styled from '@emotion/styled';
import { useEffect, useRef } from 'react';
import { isValidBase64Data } from '@hotjar/common';
import { Layer } from '../Layer/Layer';
import { loadImage } from '../../lib/loadImage';
import { heatCanvasRenderer } from '../../lib/heatmapCanvasRenderer';
import { registerLayer, unregisterLayer } from '../../lib/heatmapLayersManager';

const Canvas = Layer.withComponent(styled.canvas`
  width: 100%;
`);

interface HeatLayerProps {
  heatmapImageData: string;
  width: number;
  height: number;
  heatmapType: HeatmapDataType;
  shouldShowHeatLayer: boolean;
}

export const HeatLayer = ({
  heatmapImageData,
  width,
  height,
  heatmapType,
  shouldShowHeatLayer,
}: HeatLayerProps): JSX.Element | null => {
  const canvasRef = useRef<HTMLCanvasElement>(null);

  useEffect(() => {
    loadImage(heatmapImageData).then((heatmapImageElement) => {
      if (canvasRef.current) {
        heatCanvasRenderer(canvasRef.current, heatmapImageElement, heatmapType !== 'scroll');
      }
    });
  }, [heatmapImageData, heatmapType]);

  useEffect(() => {
    registerLayer(canvasRef);

    return () => {
      unregisterLayer(canvasRef);
    };
  }, []);

  if (isValidBase64Data(heatmapImageData) === false || isValidBase64Data(heatmapImageData) === '') {
    return null;
  }

  return (
    <Canvas
      ref={canvasRef}
      width={width}
      height={height}
      style={{ display: shouldShowHeatLayer ? 'initial' : 'none' }}
    />
  );
};
